import type {LanguageCode} from '@/locale/locales'

type CurrencyCode = 'DKK' | 'GBP' | 'EUR' | 'USD' | 'SEK' | 'NOK'

export const getCurrencyName = (currencyCode: CurrencyCode, languageCode: LanguageCode) => {
    const currencyNames = new Intl.DisplayNames([languageCode], {type: 'currency'})

    return currencyNames.of(currencyCode)
}
